// @file phoenix socket setup
import { captureException } from 'bits/error_tracker'
import * as Phoenix from 'phoenix'

export function getSocket(accessToken: string, reconnectAfterMs: (tries: number) => number): Phoenix.Socket | null {
  try {
    const realtimeTag = document.getElementsByName('realtime-uri')[0] as HTMLMetaElement
    const socket = new Phoenix.Socket(realtimeTag.content, {
      params: { accessToken },
      reconnectAfterMs,
    })

    return socket
  } catch (e) {
    captureException(e)
  }

  return null
}
